import React from "react";
import { HRProvider } from "../HRContext";
import ContractList from "./ContractList";

const ContractListWrapper: React.FC = () => {
  return (
    <HRProvider>
      <ContractList />
    </HRProvider>
  );
};

export default ContractListWrapper;
